import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// On navigation: scroll to the hash target if present (e.g. the banner's
// "/#manifesti"), otherwise reset to the top. Anchor targets carry scroll-mt-*
// so the sticky header does not cover them.
export function ScrollManager() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(decodeURIComponent(hash.slice(1)))
      if (el) {
        el.scrollIntoView({ block: 'start' })
        return
      }
    }
    window.scrollTo(0, 0)
  }, [pathname, hash])

  return null
}
